// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { Branding_Branded_SubBrand_Fragment, Branding_Branded_TenantBranding_Fragment } from '../../admin/branding/graphql/Branding.generated';
import { SlideConfig_PresentationCoverSlideConfigFragment } from '../../../pages/admin/AdminBrandingPage/graphql/SlideConfig.generated';
import { gql } from '@apollo/client';
import { Branding_BrandedFragmentDoc } from '../../admin/branding/graphql/Branding.generated';
import { SlideConfig_PresentationCoverSlideConfigFragmentDoc } from '../../../pages/admin/AdminBrandingPage/graphql/SlideConfig.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TenantInformationFragment = { __typename?: 'TenantInformation', id: string, name: string, luminaryOrganizationID?: string | null, orgMembershipType?: Types.TenantOrgMembershipType | null, usageBucket: Types.TenantUsageBucket, kind: Types.TenantKind, tier: Types.TenantProductTier, hasPublishedReviews: boolean, assetIntegrationsEnabled: Types.FeatureEnablementStatus, projectionFunctionalityEnabled: Types.FeatureEnablementStatus, trialEndDate?: Time | null, branding: (
    { __typename?: 'TenantBranding' }
    & Branding_Branded_TenantBranding_Fragment
  ), otherTenantBranding?: Array<{ __typename?: 'OtherTenant', name: string, branding: (
      { __typename?: 'TenantBranding' }
      & Branding_Branded_TenantBranding_Fragment
    ) } | null> | null };

export type IntegrationConfigurationFragment = { __typename?: 'IntegrationConfiguration', id: string, csvValuationImportName?: string | null, emoneyEnabled: boolean, blackDiamondEnabled: boolean, orionEnabled: boolean, addeparFirmID?: string | null, addeparSubdomain?: string | null, addeparClientType: Types.IntegrationConfigurationAddeparClientType, snowflakeDataSharingEnabled: boolean, snowflakeIntegrationDisplayName?: string | null, salesforceIsWealthhub: boolean };

export type EffectiveApplicationConfigurationFragment = { __typename?: 'EffectiveApplicationConfiguration', disableAiCapabilities: boolean, disableAiInsights: boolean, disableAdvancedAnalytics: boolean, enableEmployeeIdpID: boolean, smartReviewEnabled: boolean, userSessionInactivityTimeout: Types.EffectiveApplicationConfigurationUserSessionInactivityTimeout, disclaimerConfigurationOverridesDescendants: boolean, requirePresentationApproval: Types.PresentationApprovalRequirement };

export type AssetClassFragment = { __typename?: 'AssetClass', id: string, displayName: string, isSystemClass: boolean, liquidityStatus: Types.AssetClassLiquidityStatus };

export type TenantInformationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TenantInformationQuery = { __typename?: 'Query', integrationConfiguration?: (
    { __typename?: 'IntegrationConfiguration', id: string }
    & IntegrationConfigurationFragment
  ) | null, tenantSecurityConfiguration?: { __typename?: 'TenantSecurityConfiguration', id: string, luminaryAccessControlEnabled?: boolean | null, luminarySupportAccess: Types.TenantSecurityConfigurationLuminarySupportAccess, luminarySupportAccessEndDate?: Time | null } | null, effectiveApplicationConfiguration: (
    { __typename?: 'EffectiveApplicationConfiguration' }
    & EffectiveApplicationConfigurationFragment
  ), tenantInformation: (
    { __typename?: 'TenantInformation' }
    & TenantInformationFragment
  ), subBrands: { __typename?: 'SubBrandConnection', edges?: Array<{ __typename?: 'SubBrandEdge', node?: (
        { __typename?: 'SubBrand', displayName: string, presentationCoverSlideConfig?: (
          { __typename?: 'PresentationCoverSlideConfig' }
          & SlideConfig_PresentationCoverSlideConfigFragment
        ) | null, presentationDividerSlideConfig?: (
          { __typename?: 'PresentationCoverSlideConfig' }
          & SlideConfig_PresentationCoverSlideConfigFragment
        ) | null }
        & Branding_Branded_SubBrand_Fragment
      ) | null } | null> | null }, assetClasses: { __typename?: 'AssetClassConnection', edges?: Array<{ __typename?: 'AssetClassEdge', node?: (
        { __typename?: 'AssetClass' }
        & AssetClassFragment
      ) | null } | null> | null }, openaiSdkConfigsForOpenAI: { __typename?: 'OpenaiSdkConfigConnection', edges?: Array<{ __typename?: 'OpenaiSdkConfigEdge', node?: { __typename?: 'OpenaiSdkConfig', id: string } | null } | null> | null }, coverSlideConfig?: (
    { __typename?: 'PresentationCoverSlideConfig' }
    & SlideConfig_PresentationCoverSlideConfigFragment
  ) | null, dividerSlideConfig?: (
    { __typename?: 'PresentationCoverSlideConfig' }
    & SlideConfig_PresentationCoverSlideConfigFragment
  ) | null };

export const Operations = {
  Query: {
    TenantInformation: 'TenantInformation' as const
  },
  Fragment: {
    TenantInformation: 'TenantInformation' as const,
    IntegrationConfiguration: 'IntegrationConfiguration' as const,
    EffectiveApplicationConfiguration: 'EffectiveApplicationConfiguration' as const,
    AssetClass: 'AssetClass' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TenantInformationFragmentDoc = gql`
    fragment TenantInformation on TenantInformation {
  id
  name
  luminaryOrganizationID
  orgMembershipType
  usageBucket
  kind
  tier
  hasPublishedReviews
  assetIntegrationsEnabled
  projectionFunctionalityEnabled
  trialEndDate
  branding {
    ...Branding_Branded
  }
  otherTenantBranding {
    name
    branding {
      ...Branding_Branded
    }
  }
}
    ${Branding_BrandedFragmentDoc}`;
export const IntegrationConfigurationFragmentDoc = gql`
    fragment IntegrationConfiguration on IntegrationConfiguration {
  id
  csvValuationImportName
  emoneyEnabled
  blackDiamondEnabled
  orionEnabled
  addeparFirmID
  addeparSubdomain
  addeparClientType
  snowflakeDataSharingEnabled
  snowflakeIntegrationDisplayName
  salesforceIsWealthhub
}
    `;
export const EffectiveApplicationConfigurationFragmentDoc = gql`
    fragment EffectiveApplicationConfiguration on EffectiveApplicationConfiguration {
  disableAiCapabilities
  disableAiInsights
  disableAdvancedAnalytics
  enableEmployeeIdpID
  smartReviewEnabled
  userSessionInactivityTimeout
  disclaimerConfigurationOverridesDescendants
  requirePresentationApproval
}
    `;
export const AssetClassFragmentDoc = gql`
    fragment AssetClass on AssetClass {
  id
  displayName
  isSystemClass
  liquidityStatus
}
    `;
export const TenantInformationDocument = gql`
    query TenantInformation {
  integrationConfiguration {
    id
    ...IntegrationConfiguration
  }
  tenantSecurityConfiguration {
    id
    luminaryAccessControlEnabled
    luminarySupportAccess
    luminarySupportAccessEndDate
  }
  effectiveApplicationConfiguration {
    ...EffectiveApplicationConfiguration
  }
  tenantInformation {
    ...TenantInformation
  }
  subBrands {
    edges {
      node {
        displayName
        ...Branding_Branded
        presentationCoverSlideConfig {
          ...SlideConfig_PresentationCoverSlideConfig
        }
        presentationDividerSlideConfig {
          ...SlideConfig_PresentationCoverSlideConfig
        }
      }
    }
  }
  assetClasses {
    edges {
      node {
        ...AssetClass
      }
    }
  }
  openaiSdkConfigsForOpenAI: openaiSdkConfigs(where: {provider: OPENAI}) {
    edges {
      node {
        id
      }
    }
  }
  coverSlideConfig {
    ...SlideConfig_PresentationCoverSlideConfig
  }
  dividerSlideConfig {
    ...SlideConfig_PresentationCoverSlideConfig
  }
}
    ${IntegrationConfigurationFragmentDoc}
${EffectiveApplicationConfigurationFragmentDoc}
${TenantInformationFragmentDoc}
${Branding_BrandedFragmentDoc}
${SlideConfig_PresentationCoverSlideConfigFragmentDoc}
${AssetClassFragmentDoc}`;

/**
 * __useTenantInformationQuery__
 *
 * To run a query within a React component, call `useTenantInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantInformationQuery(baseOptions?: Apollo.QueryHookOptions<TenantInformationQuery, TenantInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantInformationQuery, TenantInformationQueryVariables>(TenantInformationDocument, withFetchPolicyContext(options));
      }
export function useTenantInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantInformationQuery, TenantInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantInformationQuery, TenantInformationQueryVariables>(TenantInformationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTenantInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenantInformationQuery, TenantInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenantInformationQuery, TenantInformationQueryVariables>(TenantInformationDocument, withFetchPolicyContext(options));
        }
export type TenantInformationQueryHookResult = ReturnType<typeof useTenantInformationQuery>;
export type TenantInformationLazyQueryHookResult = ReturnType<typeof useTenantInformationLazyQuery>;
export type TenantInformationSuspenseQueryHookResult = ReturnType<typeof useTenantInformationSuspenseQuery>;
export type TenantInformationQueryResult = Apollo.QueryResult<TenantInformationQuery, TenantInformationQueryVariables>;